export default __webpack_public_path__ + "static/media/lp-01-exercise-02.19d4e96b.jpg";